import { IOrganization, IUser } from '@shared/models';

export interface State {
  loading: boolean;
  data: IUser[];
  error: string;
}

export const initialState: State = {
  loading: false,
  data: [],
  error: null
};
